const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaProducao: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'RELATORIO_RADIOLOGISTA_SINTETICO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'RELATORIO_RADIOLOGISTA_SINTETICO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'RELATORIO_RADIOLOGISTA_SINTETICO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data
            };
		
		case 'RELATORIO_RADIOLOGISTA_SINTETICO_PRODUCAO_LISTADO':
            return {
                ...state, 
                listaProducao: action.payload.data
            };

        default:
            return state;
    }
}
